import { Plugin, PluginKey, TextSelection, } from "prosemirror-state";
import { ReactPluginView } from "../../../react";
import { AiPopupPluginView } from "../components/AiPopupPluginView/AiPopupPluginView";
import { Decoration, DecorationSet } from "prosemirror-view";
export const aiPluginKey = new PluginKey("aiPluginKey");
/** This method will run everytime the Space key is pressed and,
 * we will check if we are at the beginning of the line and if so we open the ai popup
 */
const handleSpaceKeyPress = (view) => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { state, dispatch } = view;
    const { selection } = state;
    if (selection instanceof TextSelection && selection.$cursor) {
        const cursorPos = selection.$cursor.pos;
        const lineStart = selection.$cursor.start();
        const textBeforeCursor = state.doc.textBetween(lineStart, cursorPos);
        // If we are at the beginning of the line, open the ai dialog
        if (textBeforeCursor === "") {
            const isVisible = (_a = getAiPluginState(state)) === null || _a === void 0 ? void 0 : _a.visible;
            dispatch(setAiPluginState(state, { visible: !isVisible }));
            return true;
        }
    }
    return false;
};
export const getAiPluginState = (state) => {
    return aiPluginKey.getState(state);
};
export const setAiPluginState = (state, meta) => {
    return state.tr.setMeta(aiPluginKey, meta);
};
export const openAiPopup = (view) => {
    view.dispatch(setAiPluginState(view.state, { visible: true }));
};
export const closeAiPopup = (view) => {
    view.dispatch(setAiPluginState(view.state, { visible: false }));
    view.focus();
};
export const aiPlugin = (portalContainer, service) => new Plugin({
    key: aiPluginKey,
    view: ReactPluginView.create({
        portalContainer,
        component: AiPopupPluginView,
        extraProps: {
            service,
        },
    }),
    state: {
        init: () => {
            return { visible: false };
        },
        apply: (tr, prev) => {
            const meta = tr.getMeta(aiPluginKey);
            if ((meta === null || meta === void 0 ? void 0 : meta.visible) !== undefined) {
                return { visible: meta.visible };
            }
            return prev;
        },
    },
    props: {
        decorations: (state) => {
            const { visible } = getAiPluginState(state);
            if (visible) {
                const { from, to } = state.selection;
                return DecorationSet.create(state.doc, [
                    Decoration.inline(from, to, { class: "ai-highlighted" }),
                ]);
            }
            return null;
        },
        handleKeyDown: (view, event) => {
            if (event.key === " " && handleSpaceKeyPress(view)) {
                event.preventDefault();
                return true;
            }
            if (event.key === "Escape") {
                view.dispatch(setAiPluginState(view.state, { visible: false }));
            }
            return false;
        },
    },
});
